import { createFileRoute } from '@tanstack/react-router';

import { ChatPage } from '../components/chat/ChatPage';

/**
 * Chat-first landing surface (DEV-16971). Layout route for `/chat`: renders the
 * thread sidebar + a main pane whose content comes from the child routes via an
 * `<Outlet>` (`/chat` index = greeting, `/chat/$threadId` = conversation). The
 * sidebar and shared chat session stay mounted across greeting↔thread
 * navigation so switching threads never remounts (or resets) the rail.
 */
export const Route = createFileRoute('/chat')({ component: ChatPage });
